import React from 'react';
import JWPlayer from '@jwplayer/jwplayer-react';

const VideoPlayer = () => {
  // Must match DOM id for jwplayer() native API
  const playerId = 'jwplayer-0';

  const playerConfig = {
    playlist: [
      {
        file: process.env.REACT_APP_JW_STREAM_URL // or hardcode for testing
        // file: 'https://vz-73d4a245-ab5.b-cdn.net/3b257731-3d14-4a50-82dd-a148186b538b/playlist.m3u8'
      }
    ],
    controls: true,
    muted: true,
    autostart: true,
    repeat: true,
  };

  const tryReconnect = () => {
    console.warn('Stream error - reconnecting in 3 seconds...');
    setTimeout(() => {
      window.location.reload();
    }, 3000);
  };

  const onReady = () => {
    console.log('✅ JW Player is ready (React wrapper)');

    const maxAttempts = 10;
    let attempts = 0;

    const checkNativePlayer = () => {
      const player = window.jwplayer?.(playerId);

      if (player && typeof player.getState === 'function') {
        console.log('✅ Native JW Player is ready');

        // Attach event listeners
        player.on('error', tryReconnect);
        player.on('playAttemptFailed', tryReconnect);

        player.on('play', () => {
          const levels = player.getQualityLevels?.();
          if (levels?.length > 0) {
            const highestIndex = 1;
            //player.setCurrentQuality(highestIndex);
            console.log('🎞 Set highest quality:', levels[highestIndex]?.label, levels);
          }
        });

        player.on('complete', () => {
          console.log('🔁 Playback complete — restarting...');
          player.play(true);
        });

      } else {
        attempts++;
        if (attempts < maxAttempts) {
          console.log('⏳ Waiting for native JW Player...');
          setTimeout(checkNativePlayer, 300);
        } else {
          console.error('❌ Native JW Player did not become ready.');
        }
      }
    };

    checkNativePlayer();
  };

  return (
    <div className="player-container">
      <JWPlayer
        playerId={playerId}
        library={`https://cdn.jwplayer.com/libraries/${process.env.REACT_APP_JW_KEY}.js`}
        config={playerConfig}
        onReady={onReady}
        onError={tryReconnect}
      />
    </div>
  );
};

export default VideoPlayer;
